import { useCachedFetch, useUser } from '../../shared/hooks';
import apiRoutes from '../../../config/api/routes';
import { useCallback } from 'react';
import { solutionsMapper } from '../../../config/api/models';
import { TrajectorySectionOrWorksheetType } from '../../../config/api/models/Trajectory';
import { ISolutionsModeState } from 'src/modules/shared/slices/solutions/entity/solutionsModeSlice';

export const usePageSolutions = (
  pageId: string,
  pageType: TrajectorySectionOrWorksheetType,
  solutionsMode?: ISolutionsModeState['solutionsMode']
) => {
  const { isTeacher } = useUser();

  const pageSolutions = useCachedFetch(['pageSolutions', pageId], apiRoutes.pageSolutions(pageId), {
    method: 'GET',
    mapper: solutionsMapper,
    options: {
      enabled:
        !!pageId &&
        !['worksheet_exercises', 'worksheet_evaluation'].includes(pageType) &&
        isTeacher &&
        solutionsMode,
      cacheTime: 1000,
    },
  });

  const refetch = useCallback(() => pageSolutions.refetch().then(), [pageSolutions]);

  return {
    solutions: pageSolutions?.data,
    refetch,
  };
};
